// COMPONENTS
import report_definition_display from './report_definition/report_definition.js';
import report_results_view from './report_results/report_results_view.js';

export default [
	report_definition_display,
	report_results_view
];
